import { Box, Button, Divider, Flex, Popover, Switch, Text } from '@mantine/core';
import { useState } from 'react';

type PagesFilterProps = {
  activePages: Set<string>;
  togglePage: (page: string) => void;
  pageIds: string[];
  onSelectAll: () => void;
  onReset: () => void;
};

export const PagesFilter = ({
  activePages,
  pageIds,
  togglePage,
  onSelectAll,
  onReset,
}: PagesFilterProps) => {
  const [opened, setOpened] = useState(false);

  return (
    <Popover opened={opened} onClose={() => setOpened(false)} position="bottom" withArrow>
      <Popover.Target>
        <Box style={{ alignSelf: 'center' }}>
          <Button size="sm" variant="default" onClick={() => setOpened((o) => !o)}>
            TOGGLE PAGES
          </Button>
        </Box>
      </Popover.Target>

      <Popover.Dropdown
        style={{
          minWidth: 250,
          maxHeight: 250,
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
        }}
      >
        <Box style={{ maxHeight: 180, overflowY: 'auto' }}>
          {pageIds.map((page) => (
            <Flex
              key={page}
              align="center"
              justify="space-between"
              style={{ padding: '2px 4px' }}
              gap={10}
            >
              <Text size="sm">{page}</Text>
              <Switch size="xs" checked={activePages.has(page)} onChange={() => togglePage(page)} />
            </Flex>
          ))}
        </Box>

        <Divider my="xs" />

        <Flex justify="space-between">
          <Button
            size="xs"
            variant="default"
            onClick={onSelectAll}
            disabled={pageIds.length === activePages.size}
          >
            Select All
          </Button>
          <Button size="xs" variant="default" onClick={onReset} disabled={activePages.size === 0}>
            Reset All
          </Button>
        </Flex>
      </Popover.Dropdown>
    </Popover>
  );
};
